import { render, staticRenderFns } from "./BookReview.vue?vue&type=template&id=e5d8d15a&scoped=true"
import script from "./BookReview.vue?vue&type=script&lang=js"
export * from "./BookReview.vue?vue&type=script&lang=js"
import style0 from "./BookReview.vue?vue&type=style&index=0&id=e5d8d15a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5d8d15a",
  null
  
)

export default component.exports